export const _setCaseManager = (state, action) => {
  state.caseManager = action.payload;
};

export const _setReferralType = (state, action) => {
  state.referralType = action.payload;
};

export const _setStartDate = (state, action) => {
  state.startDate = action.payload;
};

export const _setEndDate = (state, action) => {
  state.endDate = action.payload;
};

// export const _setCbpCmID = (state, action) => {
//   state.CbpCmID = action.payload;
// };
